import { Component } from '@angular/core';

@Component({
  selector: 'ng-casto-loader',
  standalone: true,
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  constructor() {}
}
